"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.linkListMock = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
const linkListMock = exports.linkListMock = {
    __typename: 'EditorialLinkList',
    id: '7452fc48-41df-48a6-8ede-5c8dab3642ae',
    title: 'Title',
    linkItems: [
        {
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link1 Title',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com/1',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link 2 Title',
            link: {
                __typename: 'Link',
                id: 'https://google.com',
                relativeUrl: 'https://google.com/2',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            __typename: 'EditorialLinkListItem',
            downloadable: true,
            title: 'Document PDF',
            link: {
                __typename: 'Link',
                id: 'https://media-uat-cdn.oriflame.com/static-media-web/ca919d20-5395-4fd7-a6d3-e1b2cc5e2aa9?mimeType=application%2fpdf',
                relativeUrl: 'https://media-uat-cdn.oriflame.com/static-media-web/ca919d20-5395-4fd7-a6d3-e1b2cc5e2aa9?mimeType=application%2fpdf',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        },
        {
            __typename: 'EditorialLinkListItem',
            downloadable: false,
            title: 'Link 4 Title',
            link: {
                __typename: 'Link',
                id: 'https://google.com/4',
                relativeUrl: 'https://google.com',
                title: '',
                type: _editorialFetching.LinkType.Custom,
                appLink: null
            }
        }
    ]
};
